export default __webpack_public_path__ + "static/media/scenario-a-support-community.5c4bdf7b.png";